import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { get } from '../../../lib/api'
import { Text, Box } from '../../../designSystem'
import Tooltip from '../../../CustomTooltip'
import InfoIcon from '../../../components/Images/InfoIcon'
import { dummy_entity_id_for_all_book } from './constants'
import Loader from '../../../components/Loader'
import { useInfiniteScroll } from '../../../lib/customHooks'

dayjs.extend(customParseFormat)

const card = {
  backgroundColor: 'surface.foreground',
  p: '16px',
  display: 'flex',
  alignItems: 'center',
  mb: '4px'
}

const DateBox = styled.div`
  display: flex;
  align-items: center;
`
const FlexBox = styled.div`
  display: flex;
 flex-direction:column;
 width:85%;
 @media (max-width: 600px) {
  width:78%
  }
 @media (max-width: 400px) {
  width:76%
  }
`

const TransId = styled.p`
    font-family: inherit;
    font-weight: 600;
    font-size: 16px;
    color: var(--storm-text-storm-700);
    margin-top: 0;
    letter-spacing: normal;
    font-weight: bold;
    margin-bottom: 4px;
    @media (max-width: 600px) {
      font-size: 12px;
  }
  @media (max-width: 400px) {
      font-size: 10px;
  }
`

const DebitDiv = styled.p`
 font-family: inherit;
    line-height: 28px;
    font-size: 16px;
    margin-top: 0;
    margin-bottom: 0;
    letter-spacing: normal;
    font-weight: 600;
    margin-right: 5px;
    color: #dd3623;
    @media (max-width: 600px) {
      font-size: 14px;
  }
    @media (max-width: 400px) {
      font-size: 12px;
  }
`

const WithdrawalHistory = ({ bookSelected, payoutTabSelected,walletDetails }) => {
  const [trxnArr, setTrxnArr] = useState([])
  const [currencySymbol, setCurrencySymbol] = useState()
  const [isLoading,setIsLoading] = useState(true)
  const [nextUrl, setNextUrl] = useState(null)
  const fetchBalanceHistory = () => {
    const api = bookSelected === dummy_entity_id_for_all_book ? `/content_api/book.get_withdrawals?time_period=${payoutTabSelected}&wallet_id=${walletDetails?.wallet_id}` : `/content_api/book.get_withdrawals?book_id=${bookSelected}&time_period=${payoutTabSelected}&wallet_id=${walletDetails?.wallet_id}`
    get(api, {params: {is_novel: 1}}).then(res => {
      const { result,currency,next_url } = res
      setNextUrl(next_url)
      setCurrencySymbol(currency)
      setTrxnArr(result)
      setIsLoading(false)
    })
      .catch((error) => {
        setIsLoading(false)
        throw error
      })
  }
  useEffect(() => {
    if (walletDetails?.wallet_id){
      fetchBalanceHistory()
    }
  }, [walletDetails])

  const fetchMoreBalanceHistory = (setIsFetching) => {
    if(!nextUrl){
      setIsFetching(false)
      return
    }
    get(nextUrl).then(res => {
      const { result,currency,next_url } = res
      setNextUrl(next_url)
      setCurrencySymbol(currency)
      setTrxnArr((prevTrxn) => prevTrxn.concat(result))
      setIsFetching(false)
    })
      .catch((error) => {
        setIsFetching(false)
        throw error
      })
  }
  const isMobile = window.screen.width < 600
  // const isFetching = useInfiniteScroll(fetchMoreBalanceHistory)
  if(isLoading) return <Loader />

  return (
    <>
      {!isMobile &&
        <Box {...card}>
          <Text variant="titleSecondary" fontWeight="r">Description</Text>
          <Text variant="titleSecondary" fontWeight="r" ml="auto" textAlign="right" >Amount</Text>
        </Box>
      }
      {trxnArr?.map(
        ({ book_title, debit, reference_id, transaction_id, txn_month_end_date, txn_month_start_date }, i) => (
          <Box
            variant="flex"
            bg="surface.foreground"
            flexDirection="row"
            p={16}
            my={4}
            key={`transaction-entry-${i}`}
          >
            <FlexBox variant="flex" flexDirection="column">
            {transaction_id && 
              <TransId>
                TRANSACTION ID {transaction_id}
              </TransId>
            }
              {book_title && <Text variant="smallText" mb={2}>{book_title}</Text>}
              {reference_id &&
                <Text variant="smallText" mb={2}>
                  REFERENCE ID {reference_id}
                </Text>}
              <DateBox>
                <Text variant="subtext" textAlign="left">
                  {txn_month_start_date && dayjs(txn_month_start_date).format('DD MMM YYYY')}
                </Text>
                <Text variant="subtext" textAlign="left">&nbsp;-&nbsp;</Text>
                <Text variant="subtext" textAlign="left">
                  {txn_month_end_date && dayjs(txn_month_end_date).format('DD MMM YYYY')}
                </Text>
              </DateBox>
            </FlexBox>
            {debit &&
            <Box variant="flex" flexDirection="row">
              <DebitDiv >{`- ${currencySymbol === 'USD' ? '$' : '₹'}${debit}`}</DebitDiv>
              <Tooltip
                content="TDS deduction of 1% if valid pan card is submitted & if not 20%"
                direction="left"
              >
                <InfoIcon />
              </Tooltip>
            </Box>
            }
          </Box>
        ))
      }
      {/* {isFetching && <Loader />} */}
    </>
  )
}

export default WithdrawalHistory
